<template>
  <div>
    <b-row>
      <b-col cols="1">
        <b-input-group-append v-b-tooltip.hover title="Вы можете указать CVE для поиска связанных эксплойтов через Metasploit">
          <b-button variant="outline">
            <b-icon icon="info-circle-fill" variant="info"/>
          </b-button>
        </b-input-group-append>
      </b-col>
      <b-col cols="9">
        <b-form>
          <b-form-group :invalid-feedback="invalidCve">
            <b-form-input type="text" v-model="cve" placeholder="CVE" :state="cveState" autofocus/>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col cols="2">
        <b-button variant="outline" @click="create" v-b-tooltip.hover title="Создать">
          <p class="h3"><b-icon variant="success" icon="plus-square-fill"/></p>
        </b-button>
      </b-col>
    </b-row>
    <b-table stripped head-variant="light" :fields="fields" :items="data" v-if="data.length > 0">
      <template #cell(actions)="row">
        <b-button variant="outline" @click="selectedItem = row.item" v-b-tooltip.hover title="Удалить" v-b-modal="'delete-vulnerability-modal'">
          <b-icon variant="danger" icon="trash-fill"/>
        </b-button>
      </template>
    </b-table>
    <deletion id="delete-vulnerability-modal" title="Удалить уязвимость" @deletion="deleteVulnerability" @clean="selectedItem = null" v-if="selectedItem !== null">
      <span>уязвимость <strong>{{ selectedItem['cve'] }}</strong></span>
    </deletion>
    <pagination :page="page" :limit="limit" :limits="limits" :total="total" name="vulnerabilities" @pagination="pagination"/>
  </div>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi';
import Deletion from '@/common/Deletion';
import Pagination from '@/common/Pagination';
export default {
  name: 'vulnerabilityModal',
  mixins: [RekonoApi],
  props: {
    targetId: Number,
  },
  computed: {
    fields () {
      let fields = [
        { key: 'cve', label: 'CVE', sortable: true }
      ]
      if (this.auditor.includes(this.$store.state.role)) {
        fields.push({ key: 'actions', label: 'Действия', sortable: false })
      }
      return fields
    }
  },
  data () {
    this.fetchData()
    return {
      limit: 10,
      limits: [10, 25, 50, 100],
      data: [],
      selectedItem: null,
      cve: null,
      invalidCve: 'CVE обязательно',
      cveState: null
    }
  },
  components: {
    Deletion,
    Pagination
  },
  methods: {
    fetchData () {
      return this.getOnePage('/api/parameters/vulnerabilities/', { o: 'cve', target: this.targetId })
        .then(response => {
          this.data = response.data.results
          this.total = response.data.count
        })
    },
    check () {
      this.cveState = null
      if (!this.validateCve(this.cve)) {
        this.cveState = false
        this.invalidCve = this.cve && this.cve.length > 0 ? 'Неверный CVE' : 'CVE обязательно'
        return false
      }
      return true
    },
    create () {
      if (this.check()) {
        this.post(
          '/api/parameters/vulnerabilities/',
          { target: this.targetId, cve: this.cve },
          this.cve, 'Новая уязвимость цели создана успешно'
        )
          .then(() => this.fetchData())
        this.clean()
      }
    },
    deleteVulnerability () {
      this.delete(`/api/parameters/vulnerabilities/${this.selectedItem.id}/`).then(() => this.fetchData())
    },
    clean () {
      this.selectedItem = null
      this.cve = null
      this.invalidCve = 'CVE обязательно'
      this.cveState = null
    }
  }
}
</script>
